import CardsList from "@/components/cardsList";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 3 }}
      title={FEATURES_CONSTANTS.title}
      list={FEATURES_CONSTANTS.list}
      spacing={{ base: 8, md: 16 }}
      hoverEffect
    />
  );
};

export default FeaturesComponent;
